
$(document).ready(function() {
   
  let tgtnext = document.querySelector(".glider-next-3");
  let tgtprev = document.querySelector(".glider-prev-3");
  let tgtMain = document.querySelector(".Just_like_second_container");
  if(tgtnext) {
    tgtnext.addEventListener("click", function() {
      scrollReview(1000);
       tgtnext.style.opacity = '1';
      tgtprev.style.opacity = '1';
    });
  }
 if(tgtprev) {
    tgtprev.addEventListener("click", function() {
      scrollReview(-1000);
      tgtprev.style.opacity = '0.2';
    });
  }
  function scrollReview(amount) {
    tgtMain.scrollBy({ left: amount, behavior: 'smooth' });
  }

let tgt_read_more = document.querySelectorAll(".moreless-button");
tgt_read_more.forEach((item) => {
  item.addEventListener('click', function(e) {
    let tgt_para = e.target.parentElement.querySelector("p");
    let tgtmainparent = e.target.parentElement.parentElement;

    if (tgt_para.classList.contains("moretext")) {
      tgt_para.classList.remove("moretext");
      item.innerHTML = "Read Less <i class='fa fa-angle-down'></i>";
      tgtmainparent.style.backgroundColor ="#0f0b09";
      // console.log("tgtmainparent" , tgtmainparent)
      tgtmainparent.querySelector(".just_like_blogs_cards img").style.opacity="0.2"
      target.innerHTML = "<p>CONTENTS</p>";
    } else {
        tgtmainparent.style.backgroundColor ="";
        // console.log("tgtmainparent" , tgtmainparent)
        tgtmainparent.querySelector("img").style.opacity="0.8"
        tgt_para.classList.add("moretext");
        item.innerHTML = "Read More <i class='fa fa-angle-up'></i>"
    }
  });

});

$(".readmore").click(function(){
var imageCardSlider = $(this).closest(".image-card-slider");
imageCardSlider.toggleClass("hrvest");

if (imageCardSlider.hasClass("hrvest")) {
  $(this).html('Read less <svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>');
} else {
  $(this).html(' Read more <svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg>');
}
});


/***************for thumnails in pdp *****************/

if($(window).width() > 480){
  $('body').on('click', '[name="Pack"]', function(){
    var variant_val = $(this).val();
    $('.template-product .product__thumbnail').addClass('hidden').removeClass('is-active');
    $('.template-product .product__thumbnail img[alt="' + variant_val + '"]').parents('.product__thumbnail').removeClass('hidden');
    $('.template-product .product__media').parents('.product__media-item').addClass('hidden');
    $('.template-product .product__media img[alt="' + variant_val + '"]').parents('.product__media-item').removeClass('hidden');
    $('.template-product .product__thumbnail img[alt="' + variant_val + '"]').parents('.product__thumbnail').click();
    $('.template-product .product__thumbnail img[alt="' + variant_val + '"]').each(function(i){
      if(i == 0){
        $(this).parents('.product__thumbnail').addClass('is-active');
      }
    });
  });
  $(document).ready(function() {
    var selectedVariant = $('variant-radios input[checked="checked"]').val();
    if(selectedVariant) {
      $('.template-product .product__thumbnail').addClass('hidden').removeClass('is-active');
      $('.template-product .product__thumbnail img[alt="' + selectedVariant + '"]').parents('.product__thumbnail').removeClass('hidden');     
      $('.template-product .product__media').parents('.product__media-item').addClass('hidden');
      $('.template-product .product__media img[alt="' + selectedVariant + '"]').parents('.product__media-item').removeClass('hidden');
      $('.template-product .product__thumbnail img[alt="' + selectedVariant + '"]').each(function(i){
      if(i == 0){
        $(this).parents('.product__thumbnail').addClass('is-active');
      }
    });
    }
  });
};

if($(window).width() < 480){
  $('body').on('click', '[name="Pack"]',  function(){
    var variant_val = $(this).val();
    $('.template-product .thumbnail-list__item').addClass('hidden').removeClass('is-active');
    $('.template-product .thumbnail-list__item img[alt="' + variant_val + '"]').parents('.thumbnail-list__item').removeClass('hidden');
    $('.template-product .product__media').parents('.product__media-item').addClass('hidden');
    $('.template-product .product__media img[alt="' + variant_val + '"]').parents('.product__media-item').removeClass('hidden');
    $('.template-product .thumbnail-list__item img[alt="' + variant_val + '"]').parents('.thumbnail-list__item').click();
    $('.template-product .thumbnail-list__item img[alt="' + variant_val + '"]').each(function(i){
      if(i == 0){
        $(this).parents('.thumbnail-list__item').addClass('is-active');
      }
    });
  });
  $(document).ready(function() {
    var selectedVariant = $('variant-radios input[checked="checked"]').val();
    if(selectedVariant) {
      $('.template-product .thumbnail-list__item').addClass('hidden').removeClass('is-active');
      $('.template-product .thumbnail-list__item img[alt="' + selectedVariant + '"]').parents('.thumbnail-list__item').removeClass('hidden');     
      $('.template-product .product__media').parents('.product__media-item').addClass('hidden');
      $('.template-product .product__media img[alt="' + selectedVariant + '"]').parents('.product__media-item').removeClass('hidden');
      $('.template-product .thumbnail-list__item img[alt="' + selectedVariant + '"]').each(function(i){
      if(i == 0){
        $(this).parents('.thumbnail-list__item').addClass('is-active');
      }
    });
    }
  });
}

/***************End for thumnails in pdp *****************/ 



$('body').on('click', '.quantity__button[name="minus"]', function(){
var quantity__input = $('.quantity__input').parent().find('.quantity__input').val();
console.log('quantity__input',quantity__input);
if(quantity__input <= 5 && $(this).hasClass('minFive')){
  $(this).attr('disabled','disabled');  
}else if(quantity__input <= 10 && $(this).hasClass('minTen')){
  $(this).attr('disabled','disabled'); 
}
});

var cookieArr = localStorage.getItem("user");
$('.buy-it-now').click(function(){
 var code = $('.pincode.pincode-1').val();
  if(code != ''){ 
 try {
 const getData = document.getElementsByClassName("quantity__input")
  var id= $(this).attr("value");
   $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    async: false,
    data: {
      quantity: Number(getData[0].value),
      id: id
    },
    dataType: 'json',
    success: function(data) {
       window.location.href='/checkout';          
    },
    error: function(error) {
       console.log('error: ', error);
    }
    });
   }
catch(err) {

}
  }else{
   $('.modal').addClass('show-modal');
    $('body').addClass('popes');
  }
});
// endcheckout code
  $('#product-desc-acc').click(function(){
    if($(this).hasClass('showmenu')){
    $(this).parent().parent().find('.accordion-content').slideUp();
     $('#product-desc-acc').removeClass('showmenu');
    }
    else{
    $(this).parent().parent().find('.accordion-content').slideDown();
    $(this).addClass('showmenu');
    }   
 });

$('.close-button').click(function(){
  console.log('close-buttonclose-buttonclose-button');
  var user="true";
  localStorage.setItem("user",user);
  $('.modal').removeClass('show-modal');
  $('body').removeClass('popes');
  $('.first-content').removeClass('d-none');
  $('.success').removeClass('d-none');
});

 // ****************change left tab account page  start *****************

if($('body').hasClass('template-customers/account')){
  $('.forget-password-section').hide();
  $('.add_space.custom-add').hide();
  $('.order_hist').hide();
function profile() {
  $('.account-profile').show();  
  $('.order-details-block').hide();
  $('.forget-password-section').hide();
  $('.add_space.custom-add').hide();
  $('.order_hist').hide();
  $('.main-heading-account').text('Profile');   
}
   function addressBook() {
  $('.order-details-block').show();
  $('.forget-password-section').hide();
  $('.account-profile').hide(); 
  $('.order_hist').hide();
  $('.add_space.custom-add').show();
  $('.main-heading-account').text('Add a new address');   
}

function forget_password() {
  $('.forget-password-section').show();   
  $('.account-profile').hide(); 
  $('.add_space.custom-add').hide();
  $('.order-details-block').hide();
  $('.order_hist').hide();
  $('.main-heading-account').text('Change Password');   
}
    function orderhistory() {
    $('.add_space.custom-add').hide();
    $('.account-profile').hide(); 
    $('.order-details-block.delivered-order').css('display','flex');
    $('.order-details-block.cancelled-order').css('display','flex');
    $('.order-details-block.cancel-order').css('display','flex');
    $('.forget-password-section').hide();
    $('.order_hist').show();  
    $('.main-heading-account').text('Order History');  
}

function deliverorder() {
 $('.custom-add').hide();
$('.order-details-block.delivered-order').css('display','flex');
$('.order-details-block.cancelled-order').hide();
$('.forget-password-section').hide();
$('.account-profile').hide();
$('.order_hist').hide();
$('.order-details-block.cancel-order').css('display','flex');
$('.main-heading-account').text('Order & Returns');  
}

function cancelled_order_account() {
$('.custom-add').hide();
$('.order-details-block.delivered-order').hide();
$('.order-details-block.cancelled-order').css('display','flex');
$('.order-details-block.cancel-order').hide();
$('.forget-password-section').hide();
$('.account-profile').hide();
$('.order_hist').hide();
$('.main-heading-account').text('Cancelled Order');   
}
  
var account_url = window.location.search.trim();
account_url=account_url.split('=')[1];
  $('.acc_menu_list').removeClass('active');
  $('.acc_menu_list a').each(function(){
  var href_url=$(this).attr('href');
  href_url=href_url.split('v=')[1];
    if(href_url==account_url && account_url!=undefined){
     $(this).parent().addClass('active');
      console.log(href_url+'=='+account_url);
    }
  });
  if(account_url==undefined){
    $('.acc_menu_list').eq(0).addClass('active');
    $('.account-page--column-large .empty').hide();
    }
  
  
//   alert(account_url);
  if(account_url=='profile'){
  profile();
    $('.account-page--column-large .empty').hide();
  }
  if(account_url=='address'){
    addressBook();
    $('.account-page--column-large .empty').hide();
  }
  
  if(account_url=='change-password'){
  forget_password();
    $('.account-page--column-large .empty').hide();
  }
  if(account_url=='order-return'){
  deliverorder();
  }
  if(account_url=='history'){
  orderhistory();
  }
  if(account_url=='cacel-order'){
  cancelled_order_account();
  }
}
  //  account page order cancel   
var order_ids = {};
 var order_ids_reurn = {};
$('body').on('click','.OrderCancelBtn.cancel',function(){
 var order_id = $(this).attr('data-order');
 
  order_ids = localStorage.getItem('names_order_id') || [];
 if (order_ids.length > 0) {
  order_ids = JSON.parse(localStorage.getItem('names_order_id'));
}
   order_ids.push(order_id);
   localStorage.setItem("names_order_id", JSON.stringify(order_ids));
   var order_ids_21 = JSON.parse(localStorage.getItem("names_order_id"));
   console.log(order_ids_21); 
 
 $('.modal-order-poup').show();
  $('#contact_order_id').val(order_id).focus().blur();
 var product_title='';
 var i=1;
 $(this).parent().parent().find('.order-item-title').find('.item-title-order').each(function(){
 var product_name=$(this).attr('data-order-title');
   if(product_title==''){
   product_title=i+'. '+product_name;
   }
   else{
   product_title = product_title+'\n'+i+'. '+product_name;
   }
   i++;
 });
 
 $('#contact_product_name').val(product_title).focus().blur();
 var ordernum=$(this).attr('data-order-id');
$('#contact_order_number_cancel').val(ordernum).focus().blur();
 
  });

 // ****************End change left tab account page  start *****************




if($(window).width() > 750){
$('.desktop_list-slider .collection-list').slick({
    autoplay: false,
    infinite: true,
    draggable: true,
    dots: false,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow:'<button class="slick-prev slick-arrow" style=""><svg class="right_collection_svg" xmlns="http://www.w3.org/2000/svg" width="12" height="21" viewBox="0 0 12 21" fill="none"><path d="M0 3L7.5 10.5L0 18L1.5 21L12 10.5L1.5 0L0 3Z" fill="black"></path></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow" style=""><svg class="right_collection_svg" xmlns="http://www.w3.org/2000/svg" width="12" height="21" viewBox="0 0 12 21" fill="none"><path d="M0 3L7.5 10.5L0 18L1.5 21L12 10.5L1.5 0L0 3Z" fill="black"></path></svg></button>'
});
  }
const open_modal = document.querySelector(".open_modal");    
const modal = document.querySelector(".modal");
const trigger = document.querySelector(".trigger");
const test = document.querySelector(".button--small");
function toggleModal() {
  modal.classList.toggle("show-modal");
  $('body').addClass('popes');
}

function windowOnClick(event) {
  if (event.target === modal) {
      toggleModal();
      $('body').removeClass('popes');
  }
}
test.addEventListener("click", toggleModal);
open_modal.addEventListener("click", toggleModal);
trigger.addEventListener("click", toggleModal);
window.addEventListener("click", windowOnClick);



function dateformat(date) {
var dates = date, d = dates.getDate(), m = dates.getMonth(), y = dates.getFullYear(); 
m= m+1;
return (d+'/'+m+'/'+y);
}
function dileveryMessaage() {
let todayDate = new Date();
var message = 'Your order will be delivered by ', day = todayDate.getDay(), h = todayDate.getHours(), m = todayDate.getMinutes(), s = todayDate.getSeconds();
var msg = $('#buy-button').text();
if((0 < day && day < 6) && (0 <= h && h < 17) && (0 <= m && m < 61)) {
  // monday to friday and time is less than 5:30PM
  let newDate = new Date(todayDate);
  newDate.setDate(newDate.getDate() + 1)
  if(msg == 'Add to cart') {
    $('.static-message-date').removeClass('d-none');
    $('.static-message-date').text(message + dateformat(newDate));
  }else if(msg == 'Sold out') {
    $('.static-message-date').removeClass('d-none');
    $('.static-message-date').html('For bulk order please  <a class="text-props" href="https://laderach.in/pages/contact">contact us</a>.');
  }
}else if((0 < day && day < 6) && (h == 17) && (0 <= m && m < 31)) {
  // monday to friday and time is between 5:00 and 5:30
  let newDate = new Date(todayDate);
  newDate.setDate(newDate.getDate() + 1)
  if(msg == 'Add to cart') {
    $('.static-message-date').removeClass('d-none');
    $('.static-message-date').text(message + dateformat(newDate));
  }else if(msg == 'Sold out') {
    $('.static-message-date').removeClass('d-none');
    $('.static-message-date').html('For bulk order please  <a class="text-props" href="https://laderach.in/pages/contact">contact us</a>.');
  }
}else if((0 < day && day < 5) && (h == 17) && (31 <= m && m <= 60)) {
  // monday to thursday and time is 5:30PM to 6:00PM
  var newDate = new Date(todayDate);
  newDate.setDate(newDate.getDate() + 2);
  if(msg == 'Add to cart') {
    $('.static-message-date').removeClass('d-none');
    $('.static-message-date').text(message + dateformat(newDate));
  }else if(msg == 'Sold out') {
    $('.static-message-date').removeClass('d-none');
    $('.static-message-date').html('For bulk order please  <a class="text-props" href="https://laderach.in/pages/contact">contact us</a>.');
  }
}else if((0 < day && day < 5) && (18 <= h && h <= 24) && (0 <= m && m <= 60)) {
  // monday to thursday and time is more than 6:00PM
  var newDate = new Date(todayDate);
  newDate.setDate(newDate.getDate() + 2);
  if(msg == 'Add to cart') {
    $('.static-message-date').removeClass('d-none');
    $('.static-message-date').text(message + dateformat(newDate));
  }else if(msg == 'Sold out') {
    $('.static-message-date').removeClass('d-none');
    $('.static-message-date').html('For bulk order please  <a class="text-props" href="https://laderach.in/pages/contact">contact us</a>.');
  }
}else if((day == 5) && (h == 17) && (31 <= m && m <= 60)) {
  // Friday and time is 5:30PM to 6:00PM
  var newDate = new Date(todayDate);
  newDate.setDate(newDate.getDate() + (1 + 7 - newDate.getDay()) % 7);
  if(msg == 'Add to cart') {
    $('.static-message-date').removeClass('d-none');
    $('.static-message-date').text(message + dateformat(newDate));
  }else if(msg == 'Sold out') {
    $('.static-message-date').removeClass('d-none');
    $('.static-message-date').html('For bulk order please  <a class="text-props" href="https://laderach.in/pages/contact">contact us</a>.');
  }
}else if((day == 5) && (18 <= h && h <= 24) && (0 <= m && m <= 60)) {
  // Friday and time is over than 6:00PM
  var newDate = new Date(todayDate);
  newDate.setDate(newDate.getDate() + (1 + 7 - newDate.getDay()) % 7);
  if(msg == 'Add to cart') {
    $('.static-message-date').removeClass('d-none');
    $('.static-message-date').text(message + dateformat(newDate));
  }else if(msg == 'Sold out') {
    $('.static-message-date').removeClass('d-none');
    $('.static-message-date').html('For bulk order please  <a class="text-props" href="https://laderach.in/pages/contact">contact us</a>.');
  }
}else if(day == 0 || day == 6){
  // On Saturday and Sunday time does not matter
  var newDate = new Date(todayDate);
  newDate.setDate(newDate.getDate() + (1 + 7 - newDate.getDay()) % 7);
  if(msg == 'Add to cart') {
    $('.static-message-date').removeClass('d-none');
    $('.static-message-date').text(message + dateformat(newDate));
  }else if(msg == 'Sold out') {
    $('.static-message-date').removeClass('d-none');
    $('.static-message-date').html('For bulk order please  <a class="text-props" href="https://laderach.in/pages/contact">contact us</a>.');
  }
}
}

function validator(givenpincode) {
var pincodes = '110001,110002,110003,110004,110005,110006,110008,110011,110012,110015,110055,110060,110069,110031,110032,110051,110091,110092,110093,110095,110096,110030,110037,110038,110047,110061,110068,110070,110074,110007,110009,110026,110034,110035,110052,110054,110056,110063,110083,110085,110087,110088,110089,110013,110014,110016,110017,110019,110020,110021,110022,110023,110024,110025,110029,110044,110048,110049,110057,110062,110065,110066,110067,110076,110080,110090,110010,110018,110027,110028,110045,110046,110058,110059,110064,110075,110077,110078,110079,110033,110041,110042,110053,110086,122001,122002,122003,122004,122005,122007,122008,122009,122010,122011,122016,122017,122018,201301,201303,201304,201305,201307,201309,201006,201007,201009,201010,201011,201012,201014,201016,201017,201018,201019,121001,121002,121003,121006,121007,121008,121009,121010,121011,121004,121012,121013,201002,400000,400001,400002,400003,400004,400005,400006,400007,400008,400009,400010,400011,400012,400013,400014,400015,400016,400017,400018,400019,400020,400021,400022,400023,400024,400025,400026,400027,400028,400029,400030,400031,400032,400033,400034,400035,400036,400037,400038,400039,400040,400041,400042,400043,400044,400045,400046,400047,400048,400049,400050,400051,400052,400053,400054,400055,400056,400057,400058,400059,400060,400061,400062,400063,400064,400065,400066,400067,400068,400069,400070,400071,400072,400073,400074,400075,400076,400077,400078,400079,400080,400081,400082,400083,400084,400085,400086,400087,400088,400089,400090,400091,400092,400093,400094,400095,400096,400097,400098,400099,400100,400101,400102,400103,400104,400106,400107,400108,400109,400110,400111,400112,400113,400114,400125,400162,400167,400202,400210,400401,400410,400547,400609,400611,400613,400614,400617,400700,400701,400702,400703,400704,400705,400706,400707,400708,400709,400710,400713,400901,401016,401100,401101,401102,401104,401105,401106,401107,401200,401201,401202,401206,401210,401214,401301,401400,401401,401403,401406,401407,401505,401606,402204,404502,410062,410206,410208,410209,410210,410211,410213,410217,410218,410219,410221,410303,410613,410708,421006,421032,421101,421201,421202,421203,421205,421206,421300,421304,421506,421507,421604,480004';
pincodes = pincodes.replace(/\s*\,\s*/g, ",").trim().split(",");
var pincode = givenpincode;

if(pincode){
  if(pincodes.includes(pincode)){
    var cpincode = localStorage.setItem("pincode",pincode);
    var gpincode = localStorage.getItem("pincode");
    $('.pincode.pincode-1').val(gpincode);
    $('.heading').removeClass('notFoundError');
    $('.static-message').removeClass('d-none');
    $('.success-heading').show();
    $('.success-heading').text('We are delighted to inform that we are available in your area');
    dileveryMessaage();
    $('.product__pickup-availabilities.no-js-hidden').addClass('d-none');
    $('.heading').html('"We are now delivering in selected regions pan India. For deliveries in other regions, please contact us at --- Delhi- 0120-4032223, Mumbai - +91 93194 31818. <a class="text-props" href="https://laderach.in/pages/contact">contact us</a>."');
    $('.condition_heading').show();
    setTimeout(function() {
      $('.modal').removeClass('show-modal');
    },1500);
     $('body').removeClass('invalid-pincode');
     $('.delivery-massage').removeClass('d-none');
    $('body').removeClass('popes');
  }
  else{
      // $('body').addClass('invalid-pincode');
    $('.heading').html('This pincode is not serviceable. If you have bulk order then please  <a class="text-props" href="https://laderach.in/pages/contact">contact us</a>').addClass('notFoundError'); 
    var cpincode = localStorage.setItem("pincode",pincode);
    var gpincode = localStorage.getItem("pincode");
    $('.pincode.pincode-1').val(gpincode);
    $('.static-message-date').addClass('d-none');
    $('.product__pickup-availabilities.no-js-hidden').removeClass('d-none');
    $('.success-heading').hide();
    $('.condition_heading').hide();
    setTimeout(function() {
      $('.modal').removeClass('show-modal');
    },1500);
       $('.delivery-massage').addClass('d-none');
      $('body').removeClass('popes');
  } 
}else{
  $('.success-heading').hide();
   $('.delivery-massage').addClass('d-none');
  $('body').removeClass('popes');
}
}

$(document).ready(function() {
var gpincode = localStorage.getItem("pincode");
$('.pincode.pincode-1').val(gpincode);
var pincode = $('.st-pincode-input').find('.pincode.pincode-1').val();
if(pincode != ' ') {
  validator(pincode);
  $('.first-content').removeClass('d-none');
  $('.success-heading').hide();
}
});

// $('.btn-section-block').click(function() {
// var pincode = $(this).parent().find('input').val();
// validator(pincode);
// });

// $('.Pchange').click(function(){
// var pincode = $(this).parents('.st-pincode-input').find('#pdpPin').val();
// validator(pincode);
// });




/***************Account page review popup***********/   
$('body').on('click','.review_popup__form',function(e){
  var i = $(this).attr('pro_handle');
  fetch('/products/'+ i +'?view=reviews', {
    credentials: 'same-origin',
    method: 'GET'
  }).then(function (content) {    
    content.text().then(function (html) {
      // console.log(html);
      $('.review-cancellation-form').html(html);
      $('.modal-review-poup').show();
           var container = document.createElement('div');
      container.innerHTML = html;
    });
  });
  e.preventDefault();
 });
$('body').on('click','.close-review-popup',function(e){
 $('.modal-review-poup').hide();
});



//product page variant wise changed NI table
$('.input__radio__variant').click(function(){
if($(this).hasClass("gift-variant-radio")){
  var min = 0, max = 20, value = 0;
  if($(this).val() == '1 pc') {
    min = 10, value = 10;
  }else if($(this).val() == '2 pcs') {
    min = 10, value = 10;
  }else if($(this).val() == '4 pcs') {
    min = 5, value = 5;
  }
  $('.quantity__input').attr('min', min);
  $('.quantity__input').attr('max', max);
  $('.quantity__input').attr('value', value);
  $('.quantity__input').val(value);
}
// var pdvalue = $(this).attr('value');
// if(pdvalue.includes('Full Slab')) {
// var pdtitle = $('.pd__title').text();
//   if(!pdtitle.includes('- Gift Box')) {
//     $('.pd__title').html(pdtitle + ' - Gift Box');
//     $('.pd__title_mobile').html(pdtitle + ' - Gift Box');
//   }
// }
// else {
//   var pdtitle = $('.pd__title').text();
//   if(pdtitle.includes('- Gift Box') || pdtitle.includes('- Big') || pdtitle.includes('- Small')) {
//     var title = pdtitle.split('-');
//     $('.pd__title').html(title[0]);
//     $('.pd__title_mobile').html(title[0]);
//   }
// }
if($(this).attr('checked')) {
  $(this).attr('checked', "checked");
  var count = $(this).attr('count');
  $('.nut__Accordion').find('.nutri-accordion').addClass('d-none');
  $('.nutri__text').find('.text_nutri').addClass('d-none');
  var acc = $("[data-attr='"+count+"']").removeClass('d-none');
}else {
  $(this).parents('.input__label__wrapper').find('.input__radio__variant').removeAttr('checked');
  $(this).attr('checked', "checked");
  var count = $(this).attr('count');
  $('.nut__Accordion').find('.nutri-accordion').addClass('d-none');
  $('.nutri__text').find('.text_nutri').addClass('d-none');
  var acc = $("[data-attr='"+count+"']").removeClass('d-none');
}
});

$(document).ready(function(){
var chkvar =  $('.input__radio__variant[checked="checked"]').attr('value');
var checkedvNutri =  $('.input__radio__variant[checked="checked"]').attr('count');
$('.nutri__text').find('.text_nutri').addClass('d-none');
var acc = $("[data-attr='"+checkedvNutri+"']").removeClass('d-none');  

// For Qauntity capping behalf of variant
if($('.input__radio__variant[checked="checked"]').hasClass("gift-variant-radio")){
  var min = 0, max = 20, value = 0;
  if(chkvar == '1 pc') {
    min = 10, value = 10;
  }else if(chkvar == '2 pcs') {
    min = 10, value = 10;
  }else if(chkvar == '4 pcs') {
    min = 5, value = 5;
  }
  $('.quantity__input').attr('min', min);
  $('.quantity__input').attr('max', max);
  $('.quantity__input').attr('value', value);
  $('.quantity__input').val(value);
}
$('.variant-name').html(chkvar);

//  var pdtitle = $('.pd__title').text();
// if(pdtitle.includes('Box Medium')){
//    var title = pdtitle.split('Box');
//     $('.pd__title').html(title[0]);
// }
// else if(pdtitle.includes('Box Small')){
//    var title = pdtitle.split('Box');
//     $('.pd__title').html(title[0]);
// }
// else if(pdtitle.includes('Box Large')){
//    var title = pdtitle.split('Box');
//     $('.pd__title').html(title[0]);
// }
// $('.input__radio__variant').click(function(){
//   var variantvalue = $(this).attr('value');
// $('.variant-name').html(variantvalue);
    
// });
});

$(document).ready(function(){
var chkvar =  $('.input__radio__variant[checked="checked"]').attr('value');
  $('.variant-name-pt').html(chkvar + ' ' + 'Assorted Box' );

 var pdtitle = $('.pd__title').text();
if(pdtitle.includes(' 8pc Assorted')){
   var title = pdtitle.split('8pc Assorted');
    $('.pd__title').html(title[0]);
}
else if(pdtitle.includes('18pc Assorted')){
   var title = pdtitle.split('18pc Assorted');
    $('.pd__title').html(title[0]);
}
else if(pdtitle.includes('24pc Assorted')){
   var title = pdtitle.split('24pc Assorted');
    $('.pd__title').html(title[0]);
}
else if(pdtitle.includes('36pc Assorted')){
   var title = pdtitle.split('36pc Assorted');
    $('.pd__title').html(title[0]);
}
$('.input__radio__variant').click(function(){
  var variantvalue = $(this).attr('value');
$('.variant-name-pt').html(variantvalue + ' ' + 'Assorted Box' );
    
});
});

/**************** product-modal Nutri table changed code and title changed ************************/
$(document).ready(function () {
let tgt_view = document.querySelectorAll(".quick-view__summary")
tgt_view.forEach((view_item) => {
  view_item.addEventListener("click", function () {
    setTimeout(function () {

      var checkedvariant = $('.input__radio__variant__modal[checked="checked"]').attr('value');
      var giftBoxLabel = $(`.label__value[data-value="${checkedvariant}"]`);
      var min = 0, max = 20, value = 0;
      if(giftBoxLabel.hasClass('gift-variant-radio-modal')) {
        if(checkedvariant == '1 pc' || checkedvariant == '2 pcs') {
          min = 10, value = 10;
        }else if(checkedvariant == '4 pcs') {
          min = 5, value = 5;
        }
        $('.quantity__input').attr('min', min);
        $('.quantity__input').attr('max', max);
        $('.quantity__input').attr('value', value);
        $('.quantity__input').val(value);
      }
      var tgt_title = document.querySelector(".pd__title");
      var tgt_title_value = tgt_title.textContent;
      let tgt_variant = document.querySelectorAll(".label__value");
      var button_label = $('#preview__button').text();
     
      tgt_variant.forEach((variant_item) => {
       
        variant_item.addEventListener("click", function () {
         
          if(variant_item.classList.contains('gift-variant-radio-modal')) {
            var min = 0, max = 20, value = 0;
            var data_variant_value = variant_item.getAttribute('data-value');
            if(data_variant_value == '1 pc') {
              min = 10, value = 10;
            }else if(data_variant_value == '2 pcs') {
              min = 10, value = 10;
            }else if(data_variant_value == '4 pcs') {
              min = 5, value = 5;
            }
            $('.quantity__input').attr('min', min);
            $('.quantity__input').attr('max', max);
            $('.quantity__input').attr('value', value);
            $('.quantity__input').val(value);
          }
          let variant_value = variant_item.textContent;
          let title_validate = variant_value.includes("Full Slab");
          if (title_validate) {
            tgt_title.textContent = tgt_title_value + "- Gift Box";
          } else {
            tgt_title.textContent = tgt_title_value;
          }
          let variant_count = variant_item.getAttribute("count");
          
          let acc_varient = document.querySelectorAll(".nutri-accordion");
          acc_varient.forEach((acc_item) => {
           
            if (acc_item.getAttribute("data-attr") != variant_count) {
              acc_item.style.display = "none";
            } else {
              acc_item.style.display = "block";
            }
          });
        });
      });
    }, 4000);
  });
});
});

/**************** end product-modal Nutri table changed code and title changed ************************/

var pinenter = document.getElementById("PincodeEnter");
if(pinenter){
pinenter.addEventListener("keypress", PINenter);
function PINenter(event) {
  if (event.key === "Enter") {
    event.preventDefault();
      // document.getElementById("PinCheck").click();
  }
}
}
var pdppinenter = document.getElementById("pdpPin");
if(pdppinenter) {
pdppinenter.addEventListener("keypress", PDPenter);
function PDPenter(event) {
  if (event.key === "Enter") {
    event.preventDefault();
    document.getElementById("PDPPinChange").click();
  }
}
}
/*********************** origin-page slider **********/



// just-like-blog/glider



// search close icon
$(".predict--search_close").click(function(){
 $(".predictive-search-results").css("display","none");
});

$(".search__input").click(function(){
$(".predict--search_close").css("display","block");                
});


$(".has-recommendation").click(function(){
(".search__button").css("display","block");
});


// $('featured_collection.grid').mousewheel(function(e, delta) {
// this.scrollLeft -= (delta * 60);
// e.preventDefault();
// });

});
    $('body').on('click', ".gtm_add_cart", function (event) {
    var clickedElement = $(this);
    var productId = clickedElement.attr('product_id');
    var productTitle = clickedElement.attr('product_title');
    var productPrice = clickedElement.attr('product_price') / 100;
    var productType = clickedElement.attr('product_type');
    
    // Check if the price has a decimal part of .5
    if (productPrice % 1 === 0.5) {
        if (productPrice > Math.floor(productPrice)) {
            // Round up to the nearest whole number
            productPrice = Math.ceil(productPrice);
        } else {
            // Round down to the nearest whole number
            productPrice = Math.floor(productPrice);
        }
    }
    gtag('event', 'addtocart', {
        'send_to': 'GTM-M6FWJ88L',
        'product_id': productId,
        'product_title': productTitle,
        'product_price': productPrice,
        'product_type': productType
    });
});
